import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.443 2.25h.114c2.19 0 3.912 0 5.255.18 1.377.186 2.469.573 3.327 1.43.858.86 1.245 1.951 1.43 3.328.181 1.343.181 3.064.181 5.255v.114c0 2.19 0 3.912-.18 5.255-.186 1.377-.573 2.469-1.43 3.327-.86.858-1.951 1.245-3.328 1.43-1.343.181-3.064.181-5.255.181h-.114c-2.19 0-3.912 0-5.255-.18-1.377-.186-2.469-.573-3.327-1.43-.858-.86-1.245-1.951-1.43-3.328-.181-1.343-.181-3.064-.181-5.255v-.114c0-2.19 0-3.912.18-5.255.186-1.377.573-2.469 1.43-3.327.86-.858 1.951-1.245 3.328-1.43 1.343-.181 3.064-.181 5.255-.181M7.388 3.917c-1.21.163-1.933.472-2.466 1.005S4.08 6.178 3.917 7.388C3.752 8.62 3.75 10.24 3.75 12.5s.002 3.88.167 5.112c.163 1.21.472 1.933 1.005 2.466s1.256.842 2.466 1.005c1.232.165 2.852.167 5.112.167s3.88-.002 5.112-.167c1.21-.163 1.933-.471 2.466-1.005s.842-1.256 1.005-2.466c.165-1.232.167-2.852.167-5.112s-.002-3.88-.167-5.112c-.163-1.21-.471-1.933-1.005-2.466s-1.256-.842-2.466-1.005C16.38 3.752 14.76 3.75 12.5 3.75s-3.88.002-5.112.167",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }